import { render, staticRenderFns } from "./bookInfo.vue?vue&type=template&id=6948c276&"
import script from "./bookInfo.vue?vue&type=script&lang=js&"
export * from "./bookInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports